import styled from "styled-components";

export const CMArtistMomentum = styled.div((props) => ({
  margin: "40px 0",
  "& .artist-stage": {
    display: "flex",
  },
  [`@media (min-width: 2000px)`]: {
    "& h3": {
      fontSize: "3vh",
    },
    "& p": {
      fontSize: "2.5vh",
    },
  },
  [`@media ${props.theme.breakpoints.lg}`]: {
    "& .artist-stage": {},
  },
  [`@media ${props.theme.breakpoints.md}`]: {
    "& .artist-stage": {
      flexDirection: "column",
    },
  },
  [`@media ${props.theme.breakpoints.sm}`]: {
    "& .artist-stage": {
      flexDirection: "column",
    },
  },
}));

export const CMArtistStageChart = styled.div((props) => ({
  flex: 1,
  marginTop: "40px",

  "& .chart-title": {
    marginBottom: "10px",
    textAlign: "center",

    "& h6": {
      fontWeight: 700,
      display: "inline",
      position: "relative",
      fontFamily: "Inter, sans-serif",

      "& .tooltip": {
        top: "2px",
        position: "absolute",
        left: "calc(100% + 0.5rem)",
      },
    },
  },

  "& .chart-content": {
    //display: "flex",
    "& .chart-size": {
      width: "calc(100% - 150px)",
      height: "180px",
    },
    "& .chart-label": {
      height: "80%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",

      "& span": {
        background: " #f0f6ff",
        borderRadius: "6px",
        color: "#1c64f2",
        fontSize: "14px",
        fontWeight: "700",
        padding: "3px 6px",
        whiteSpace: "nowrap",
        fontFamily: "Inter,sans-serif",
      },
    },
    [`@media ${props.theme.breakpoints.lg}`]: {
      "& .chart-size": {
        width: "calc(100% - 100px)",
      },
    },
    [`@media ${props.theme.breakpoints.md}`]: {
      "& .chart-size": {
        width: "calc(40%)",
      },
    },
    [`@media ${props.theme.breakpoints.xs}`]: {
      "& .chart-options": {
        paddingTop: "2rem",
        paddingLeft: 0,
      },
      "& .chart-size": {
        width: "calc(50%)",
      },
    },
    [`@media ${props.theme.breakpoints.xss}`]: {
      "& .chart-options": {
        paddingTop: "2rem",
        paddingLeft: 0,
      },
      "& .chart-size": {
        width: "calc(60%)",
      },
    },
  },

  "& .chart-options": {
    paddingTop: "2rem",

    "& div": {
      color: "#515151",
      fontSize: "13px",
      lineHeight: "15px",
      marginBottom: "4px",
      position: "relative",
      fontFamily: "Inter,sans-serif",

      "&.active": {
        fontWeight: 600,
        color: "#1c64f2",
      },

      "& img": {
        top: "2px",
        left: "-1.5rem",
        position: "absolute",
      },
    },
  },
}));

export const CMSelect = styled.select`
  width: 100%;
  min-width: 100px;
  max-width: 200px;
  height: 31px
  border-radius: 4px;
  background-color: #fff;
  color: #000; 
  font-size: 1rem; 
  font-weight: 400; 
  margin-top:20px;

  @media (min-width: 2000px) {
    max-width: 100%;
    max-height: 100%;
     width: 40vh;
     height: 3vh;
     font-size:2vh;
     & > option {
     font-size:2vh;
     }
     margin-bottom:1vh;
  }

  & > option[value=""][disabled] {
    color: #888; 
  }

  & > option {
    color: #000; 
  }

  &::-ms-expand {
    display: none; 
  }

  &:focus {
    outline: none;
  }
`;